import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunk errors after a new deploy.
// When the browser has a cached index.html referencing chunk hashes
// that no longer exist, dynamic imports throw. Reload once to fetch
// the fresh index.html and asset manifest.
const RELOAD_KEY = "vv:chunk-reloaded";
const isChunkLoadError = (msg: string) =>
  /Importing a module script failed|Failed to fetch dynamically imported module|Loading chunk [\d]+ failed|ChunkLoadError/i.test(
    msg
  );
const tryReload = (msg: string) => {
  if (!isChunkLoadError(msg)) return;
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, "1");
  window.location.reload();
};
window.addEventListener("error", (e) => tryReload(e.message || ""));
window.addEventListener("unhandledrejection", (e) =>
  tryReload(String((e.reason && (e.reason.message || e.reason)) || ""))
);

createRoot(document.getElementById("root")!).render(<App />);
